export enum LogLevel {
  DEBUG = 'DEBUG',
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
}

export interface LogEntry {
  timestamp: string;
  level: LogLevel;
  message: string;
  labels: Record<string, string>;
  metadata?: Record<string, any>;
  error?: {
    name: string;
    message: string;
    stack?: string;
  };
}

export interface LogTransport {
  send(entry: LogEntry): Promise<void>;
  sendBatch(entries: LogEntry[]): Promise<void>;
}

export interface LoggerOptions {
  minLogLevel?: LogLevel;
  additionalLabels?: Record<string, string>;
  transport?: LogTransport;
} 